import { useLocaleContext } from 'providers/LocaleProvider';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useRouter } from 'next/router';
import { getCanonicalAttr } from 'utils/helmet';

const ContactHelmet = () => {
  const { language, locale: t } = useLocaleContext();
  const { asPath } = useRouter();

  return (
    <Helmet>
      <title>{t('hc.page.contact.title')}</title>
      <meta name="description" content={t('hc.meta.contact.description')} />
      <link {...getCanonicalAttr(language, asPath)} />
    </Helmet>
  );
};

export default ContactHelmet;
